import { toCurrency } from '@bpd-library/utilities';
import { FILTER_NAMES } from '@features/properties/components/property-filter';
import { SelectedFilter } from '@source/store/filters';
import { transformFilters } from '@source/store/filters/utilities/transform-filters';
import { useTranslate } from '@source/utilities/hooks';

export const transformFilterLabel = (name: string, filter: SelectedFilter) => {
    const transformFilter = transformFilters({ [name]: filter });

    if (transformFilter.length === 0) return null;

    const { minValue, maxValue } = transformFilter[0];

    if (!minValue && !maxValue) return null;

    const replacer = { id: 'Amount', value: minValue?.toString() || '' };

    switch (name) {
        case FILTER_NAMES.rooms:
            return useTranslate('Filters.Rooms.selectedLabel', {
                replace: [replacer],
            });
        case FILTER_NAMES.livingArea:
            return useTranslate('Filters.LivingArea.selectedLabel', {
                replace: [replacer],
            });
        case FILTER_NAMES.plotArea:
            return useTranslate('Filters.PlotArea.selectedLabel', {
                replace: [replacer],
            });
        case FILTER_NAMES.status:
        case FILTER_NAMES.districts:
        case FILTER_NAMES.projectPhases:
        case FILTER_NAMES.propertyTypes:
        case FILTER_NAMES.rental:
            return '';
        case FILTER_NAMES.priceRange:
            if (!minValue || !maxValue) return;
            return `${toCurrency(minValue)} - ${toCurrency(maxValue)}`;
        default:
            return '';
    }
};
